// extracted by mini-css-extract-plugin
export var animatedCounter = "resultcount-module--animatedCounter--a3c66";
export var fadeInRight = "resultcount-module--fadeInRight--d8916";